'use client';
import { ConfirmLeaveModalComp } from 'components';
import { useEffect } from 'react';
import { useRealTimeState } from 'scripts';

export function UsePopstateBlocker() {
    const isDirty = useRealTimeState(false);
    const confirmModal = useRealTimeState<boolean>(false);
    const allowBack = () => {
        if (isDirty.get()) {
            isDirty.set(false);
            window.history.back();
        }
    };

    const blockBack = () => {
        if (!isDirty.get()) {
            isDirty.set(true);
            window.history.pushState(null, '');
        }
    };

    useEffect(() => {
        const onPop = () => {
            if (isDirty.get()) {
                if (confirmModal.get()) {
                    confirmModal.set(false);
                } else {
                    confirmModal.set(true);
                }
                window.history.pushState(null, '');
            }
        };
        window.addEventListener('popstate', onPop);

        return () => {
            window.removeEventListener('popstate', onPop);
        };
    }, []);

    useEffect(() => {
        const handler = (e: BeforeUnloadEvent) => {
            if (!isDirty.get()) return;
            e.preventDefault();
            e.returnValue = ''; // Required for Chrome
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, []);

    const comp = (
        <ConfirmLeaveModalComp
            open={confirmModal.dep}
            onCancel={() => window.history.back()}
            onConfirm={() => {
                isDirty.set(false);
                window.history.back();
            }}
        />
    );

    return { allowBack, blockBack, comp };
}
